
import _ from "lodash";

export const getErrors = (localErrors, apiErrors) => {
    _.forOwn(apiErrors, (value, key) => {
        _.set(localErrors, key.split('.'), value);
    });
}